export default __webpack_public_path__ + "static/media/b-10.959b9c3f.png";